module.exports = __webpack_public_path__ + "static/media/0223_IMG_LE_SOL_LEGNI_WALNUT.00817ed2.webp";